import { EditQuestionnairePage } from './EditQuestionnairePage';
export default EditQuestionnairePage;
